import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {Modal} from 'react-bootstrap';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

const PopupSendMail = ({}) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const buttonClassName = `btn btn-icon btn-light btn-sm custom-action-button
                           ${(can('full', 'invoices'))
    ? ``
    : `cursor-default custom-disabled-button`}`;
  const cancelButton = intl.formatMessage({
    id: 'invoices-popup-buttonCancel',
    defaultMessage: 'Cancel',
  });
  const sendButton = intl.formatMessage({
    id: 'invoices-popup-buttonSend',
    defaultMessage: 'Send',
  });

  const sendInvoicesByEmailFunc = ({invoiceTypeID, invoiceNum, emailAddress}) => () => {
    // dispatch(actions.sendInvoicesByEmailAction({invoiceTypeID, invoiceNum, emailAddress}));
    setShow(false);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.emailAddress) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailAddress)) {
      errors.email = 'Invalid email address';
    }

    return errors;
  };

  const handleSend = () => {

  };

  return (
    <>
      <Button
        variant="outline-primary"
        className={buttonClassName}
        onClick={() => {
          handleShowModal();
        }}
        disabled={true}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Outgoing-mail_brandColor.svg')}
          alt="send-mail"
        />
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <Button
            className="btn-secondary btn-sm col-4"
            onClick={handleCloseModal}
          >
            {cancelButton}
          </Button>
          <Button
            type="submit"
            className="btn-sm col-6 mx-3 custom-send-button"
            onClick={handleSend()}
          >
            {sendButton}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSendMail;
